const isDebug = process.env.GATSBY_DEBUG_MODE === "TRUE";
const isBrowser = typeof window !== "undefined";

export { isDebug, isBrowser };
